import React from 'react';
import PropTypes from 'prop-types';
import Bingo from 'modules/Bingo';
import { connect } from 'react-redux';

export const _TicketCount = (props) => {
  const { ticketCount, freeRoom } = props;
  return (
    <div className="quickBuy__ticketCount">
      <h5>{freeRoom ? 'Claimed' : 'Purchased'}</h5>
      <div>
        <span>{ticketCount}</span>
      </div>
    </div>
  );
};
_TicketCount.propTypes = {
  ticketCount: PropTypes.number,
  freeRoom: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  refName: PropTypes.string.isRequired
};

_TicketCount.defaultProps = {
  ticketCount: 1,
  freeRoom: false
};

const mapStateToProps = (state, ownProps) => {
  const { refName } = ownProps;
  const nextPurchasedRefs = Bingo.selectors.getPurchasedTicketRefs(state, refName, 'next');
  const room = Bingo.selectors.getDisplayProps(state, refName);
  return {
    ticketCount: nextPurchasedRefs && nextPurchasedRefs.length,
    freeRoom: room && room.freeRoom
  };
};

export default connect(mapStateToProps)(_TicketCount);
